module.exports = __webpack_public_path__ + "static/media/whistledog-mb-fr.e0720db1.jpg";